import { LoginForm } from '../../components/auth/login-form'

export default function Login() {
  return <LoginForm />
}
